import { TsRestClient } from '@eluve/api-client-provider';
import { SessionUnavailableError } from '@eluve/eluve-errors';
import { Logger } from '@eluve/logger-main';

import { PrepareAudioRecordsEvent, TaskHandler } from '../types';

export const prepareAudioRecordsHandler = ({
  client,
  logger,
}: {
  client: TsRestClient | null;
  logger: Logger;
}): TaskHandler<PrepareAudioRecordsEvent> => {
  return async (task, context) => {
    if (!client) {
      logger.error('Client is not available for preparing audio records', {
        fileName: task.fileName,
      });
      throw new SessionUnavailableError('API client not available');
    }

    const response = await client.appointments.prepareAppointmentAudioRecords({
      params: {
        tenantId: context.tenantId,
        appointmentId: task.appointmentId,
      },
      body: {
        fileName: task.fileName,
        useResumableUploads: task.useResumableUploads,
        origin: task.origin,
        userAgent: task.userAgent,
        microphoneName: task.microphoneName,
        metadata: task.metadata,
        deviceId: task.deviceId,
      },
      fetchOptions: { signal: context.signal },
    });

    if (response?.status === 401) {
      throw new SessionUnavailableError(
        'Session expired while preparing audio records',
      );
    }

    if (response?.status === 403) {
      logger.warn('Appointment not accessible while preparing audio records', {
        appointmentId: task.appointmentId,
        fileName: task.fileName,
      });
      return;
    }

    if (response?.status !== 200) {
      logger.error('Failed to prepare appointment audio records', {
        fileName: task.fileName,
        status: response?.status,
      });

      throw new Error('Failed to prepare appointment audio records');
    }
  };
};
